import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import Toggle from 'react-toggle';
import sqarelogo from './img/squarelogo.png';
import GreenLoading from './components/GreenLoading';
import ErrorScreen from './components/ErrorScreen';
import { firebaseAuth } from './firebase.js';

function ResetBudget(props) {
    let navigate = useNavigate();
    const [resetEnabled, setResetEnabled] = useState(false);
    const [resetting, setResetting] = useState(false);
    const [isErrorResetting, setIsErrorResetting] = useState(false);
    const [email, setEmail] = useState('');
    const [idToken, setIdToken] = useState('');

    React.useEffect(() => {
        firebaseAuth.onAuthStateChanged(function (user) {
            if (user) {
                setEmail(user.email);
                user.getIdToken().then(token => {
                    setIdToken(token);
                });
            } else {
                navigate('/Login');
            }
        });
    }, [navigate]);

    const dbURL = 'https://vermillionapp.fly.dev/';

    const api_reset_budget = () => {
        const data = { token: idToken };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({})
        };
        const baseURL = dbURL + 'resetBudget?';
        const reqURL = baseURL + 'token=' + encodeURIComponent(data.token);
        console.log(reqURL);
        // return(1);
        return fetch(reqURL, requestOptions)
            .then((response) => response.json())
            .catch((error) => {
                console.error(error);
                throw error;
            });
    };

    const attemptReset = () => {
        setResetting(true);
        api_reset_budget().then((data) => {
            if (data && data.code === 1) {
                setTimeout(() => {
                    navigate('/Budget');
                }, 1000);
            } else {
                setIsErrorResetting(true);
            }
        });
    };

    function ResetBudgetPage() {
        if (resetting) {
            return <GreenLoading buttonList={[['Back to Budget', '']]} />;
        }
        return (
            <>
                {/* Back button in upper left, outside white area, not fixed */}
                <div className='d-none d-lg-block greyBG' style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 1000, margin: '24px' }}>
                        <div style={{ cursor: 'pointer', color: '#3d3a3a', fontWeight: 'bold', fontSize: '18px', display: 'flex', alignItems: 'center', background: 'transparent', borderRadius: '8px', padding: '8px 16px' }} onClick={() => navigate('/Settings')}>
                            <span style={{ fontSize: '22px', marginRight: '8px' }}>&larr;</span> Back to Settings
                        </div>
                    </div>
                    <div className='d-flex justify-content-center mt-5'>
                        <div className='app d-flex flex-column p-5'>
                            <div className='w-100 mt-5 align-content-center' style={{ textAlign: 'center' }}>
                                <img src={sqarelogo} className='navLogo' alt="..." />
                            </div>
                            <div className="d-grid gap-2 mt-auto mb-1 align-content-center">
                                <div className='row mt-5 mb-3'>
                                    <div className='text-center mb-3 h1' style={{ color: "#3d3a3a" }}>
                                        Ready to clear off the cobwebs?
                                    </div>
                                    <div className='text-center mb-3 h5' style={{ color: "#3d3a3a" }}>
                                        Click the button below to reset your budget and start fresh!
                                    </div>
                                </div>
                                <div className="container">
                                    <div className="row mb-1">
                                        <div className="col-1" id="confirmToggleDiv">
                                            <Toggle
                                                id='confirmToggle'
                                                defaultChecked={resetEnabled}
                                                icons={false}
                                                onChange={() => setResetEnabled(!resetEnabled)}
                                            />
                                        </div>
                                        <div className="col">
                                            <div className="confirmToggleLabel">I understand that:</div>
                                        </div>
                                    </div>
                                </div>
                                <ul>
                                    <li>Any accounts or transactions I previously logged will be deleted.</li>
                                    <li><b>Deletion is permanent and can't be undone.</b></li>
                                </ul>
                                <div className='row'>
                                    <div
                                        className={`button button-darkRed p-2 w-75 ${!resetEnabled ? 'disabled' : ''}`}
                                        style={{ backgroundColor: '#f65f4b', borderRadius: '50px', textAlign: 'center', fontSize: '20px' }}
                                        onClick={() => {
                                            if (resetEnabled) {
                                                attemptReset();
                                            }
                                        }}
                                        disabled={!resetEnabled}
                                    >
                                        Reset Budget
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
                {/* Mobile */}
                <div className='d-block d-lg-none' style={{ position: 'relative', background: '#fff', minHeight: '100vh' }}>
                    <div style={{ position: 'absolute', top: 8, left: 8, zIndex: 1000, margin: '8px' }}>
                        <div style={{ cursor: 'pointer', color: '#3d3a3a', fontWeight: 'bold', fontSize: '18px', display: 'flex', alignItems: 'center', background: 'transparent', borderRadius: '8px', padding: '8px 16px' }} onClick={() => navigate('/Settings')}>
                            <span style={{ fontSize: '22px', marginRight: '8px' }}>&larr;</span> Back to Settings
                        </div>
                    </div>
                    <div className='app d-flex flex-column'>
                        <div className="d-grid gap-2 mt-auto">
                            <div style={{ height: '48px' }} />
                            <div style={{ marginBottom: '32px' }} />
                            <div className='w-100 mt-3 align-content-center mb-5' style={{ textAlign: 'center' }}>
                                <img src={sqarelogo} className='navLogo' alt="..." />
                            </div>
                            <div className='row mt-5 mb-3'>
                                <div className='text-center mb-3 h1' style={{ color: "#3d3a3a" }}>
                                    Ready to clear off the cobwebs?
                                </div>
                                <div className='text-center h5' style={{ color: "#3d3a3a" }}>
                                    Click the button below to reset your budget and start fresh!
                                </div>
                            </div>
                            <div className="d-grid gap-2 mt-auto mb-1 align-content-center ps-3 pe-3">
                                <div className="container" style={{ width: "fit-content" }}>
                                    <div className="row mb-3">
                                        <div className="col-1" id="confirmToggleDiv">
                                            <Toggle
                                                id='confirmToggle'
                                                defaultChecked={resetEnabled}
                                                icons={false}
                                                onChange={() => setResetEnabled(!resetEnabled)}
                                            />
                                        </div>
                                        <div className="col">
                                            <div className="confirmToggleLabel">I understand that:</div>
                                        </div>
                                    </div>
                                </div>
                                <ul>
                                    <li>Any accounts or transactions I previously logged will be deleted.</li>
                                    <li><b>Deletion is permanent and can't be undone.</b></li>
                                </ul>
                                <div className='row'>
                                    <div
                                        className={`button button-darkRed p-2 w-50 ${!resetEnabled ? 'disabled' : ''}`}
                                        style={{ backgroundColor: '#f65f4b', borderRadius: '50px', textAlign: 'center', fontSize: '20px' }}
                                        onClick={() => {
                                            if (resetEnabled) {
                                                attemptReset();
                                            }
                                        }}
                                        disabled={!resetEnabled}
                                    >
                                        Reset Budget
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return <ResetBudgetPage />;
}

export default ResetBudget; 